<template>
  <div id="app" class="height:100vh;">
    <appHeader />
    <router-view />
    <appFooter v-if="showFooter"/>
  </div>
</template>

<script>

import { computed } from 'vue';
import { useRoute } from 'vue-router';
import appFooter from './components/appFooter.vue';

export default {
  name: 'App',
  components: {
    appFooter
  },
  setup() {
    const route = useRoute();
    
    const showFooter = computed(() => {
      return route.meta.showFooter !== false;
    });
    
    return {
      showFooter
    };
  }
}
</script>

<style scoped>
/* 可以添加全局样式 */
</style> 